// extracted by mini-css-extract-plugin
export default {"marker":"Map_marker__y6m2I"};